import { render, staticRenderFns } from "./TablaMobile.vue?vue&type=template&id=ff35b5be&scoped=true"
import script from "./TablaMobile.vue?vue&type=script&lang=js"
export * from "./TablaMobile.vue?vue&type=script&lang=js"
import style0 from "./TablaMobile.vue?vue&type=style&index=0&id=ff35b5be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff35b5be",
  null
  
)

export default component.exports